import { CircularProgress } from "@mui/material"
import { memo } from "react"
import { useSelector } from 'react-redux'
import CustomInput from "../../components/inputs/CustomInput"
import CustomDialog from "../../components/layouts/common/CustomDialog"
import { CenteredBox } from "../../components/layouts/OneViewBox"
import FileInput from "../../components/inputs/FileInput"

const CreateUi = ({ title, modalKey, isUpdate, fields, setFields, loading, onSubmit }) => {
    const { user } = useSelector(state => state)
    return <>

        <CustomDialog
            id={modalKey}
            loading={loading}
            err={fields.err}
            onSubmit={onSubmit}
            title={`${isUpdate ? "Update" : "Create"} ${title}`}
            closeText="Close"
            confirmText={`${isUpdate ? "Update" : "Create"}`}
        >

            {loading ? <CenteredBox><CircularProgress /></CenteredBox> :
                <>
                    {<CustomInput
                        autoFocus={true}
                        disabled={loading}
                        value={fields.name}
                        onChange={(e) => setFields({ ...fields, err: '', name: e.target.value })}
                        type="text"
                        label={"Audio Name*"}
                    />}
                    {
                        <FileInput
                            key={loading}
                            onDelete={() => {
                                setFields({ ...fields, url: '' })
                            }}
                            defaults={fields.url ? [fields.url] : []}
                            title="Audio Track*"
                            subTitle="Only .png,.jpg,.jpeg  less than 2mb are valid."
                            accept="audio/*"
                            onChange={(newUrl) => {
                                setFields({ ...fields, url: newUrl })
                            }} />

                    }
                </>}

        </CustomDialog>
    </>
}
export default memo(CreateUi)